import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Currency } from '@services/insight/type';

export interface CurrencyState {
  currency: Currency | null;
  isLoading: boolean;
  isReady: boolean;
}

const initialState: CurrencyState = {
  currency: null,
  isLoading: false,
  isReady: false,
};

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    setCurrencyLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setCurrencyData: (state, action: PayloadAction<Currency | null>) => {
      state.currency = action.payload;
      state.isLoading = false;
      state.isReady = true;
    },
    resetCurrency: () => initialState,
  },
});

export const { setCurrencyLoading, setCurrencyData, resetCurrency } = currencySlice.actions;
export default currencySlice.reducer;
